import { render } from "./SingleQuote.vue?vue&type=template&id=0508cfac&scoped=true"
import script from "./SingleQuote.vue?vue&type=script&lang=js"
export * from "./SingleQuote.vue?vue&type=script&lang=js"

import "./SingleQuote.vue?vue&type=style&index=0&id=0508cfac&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0508cfac"]])

export default __exports__